import "./Footer.css"
import {Common} from "../../app/Common";

export function Footer() {
	// @ts-ignore
	const Web = <div id="footer" mode="web">
		<div className="content1">
			POKERDAO
		</div>
		<div className="content2">
			<img src={require('../../assets/discord-black.png')}
					 onClick={Common.toDiscord}/>
			<img src={require('../../assets/twitter-black.png')}
					 onClick={Common.toTwitter}/>
		</div>
		<div className="line"/>
		<div className="text">
			© PokerDAO, Inc. 2022. We love our users!
		</div>
	</div>

	// @ts-ignore
	const Mobile = <div id="footer" mode="mobile">
		<div className="content1">
			POKERDAO
		</div>
		<div className="content2">
			<img src={require('../../assets/discord-black.png')}
					 onClick={Common.toDiscord}/>
			<img src={require('../../assets/twitter-black.png')}
					 onClick={Common.toTwitter}/>
		</div>
		<div className="line"/>
		<div className="text">
			© PokerDAO, Inc. 2022. We love our users!
		</div>
	</div>

	return Common.isMobile ? Mobile : Web
}

